import { createFileRoute } from "@tanstack/react-router";
import AdminSettingsPage from "lib/components/admin/settings/AdminSettingsPage";
import withAuthentication from "../../components/withAuthentication";

export const Route = createFileRoute("/admin/settings")({
  component: withAuthentication(AdminSettingsPage, { superAdmin: true }),
});
